import { Component, EventEmitter, Output } from "@angular/core";
import { LocalStorage } from "src/libs/storage/src";
import { StorageKey } from "src/app/enums/storage-key";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-trial-subscription-modal",
  templateUrl: "./trial-subscription-modal.component.html",
  styleUrls: ["./trial-subscription-modal.component.scss"],
})
export class TrialSubscriptionModalComponent {
  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(
    private readonly _modalService: ModalService,
    private readonly _localStorage: LocalStorage
  ) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.TrialSubscription;
  }

  onClose() {
    this._localStorage.setItem(StorageKey.HasSeenTrialSubscriptionModal, "true");
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit() {
    this._localStorage.setItem(StorageKey.HasSeenTrialSubscriptionModal, "true");
    this._modalService.closeModal();
    this.submit.emit();
  }
}
